import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ app_name: "CRM", app_subtitle: "Leads Console", logo_url: "" });

export function AppSettingsProvider({ children }) {
  const [settings, setSettings] = useState({ app_name: "CRM UT Mataram", app_subtitle: "Leads Console", logo_url: "" });
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/app-settings");
      setSettings(data);
    } catch {}
  }, []);
  useEffect(() => { reload(); }, [reload]);

  // Sync browser favicon to the CRM logo
  useEffect(() => {
    if (!settings.logo_url) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = settings.logo_url;
  }, [settings.logo_url]);

  return <Ctx.Provider value={{ ...settings, reload }}>{children}</Ctx.Provider>;
}

export const useAppSettings = () => useContext(Ctx);
